import React from 'react';

// Two-value pill toggle (Load Type: FTL/LTL, Freight on: Order/Shipment,
// border-crossing Direction: Outbound/Inbound, ...). Styling lives in
// CreateLoad.css (.slide-toggle*) but the whole app's CSS bundles together,
// so it's safe to use anywhere, not just inside CreateLoad.
export default function SlideToggle({ value, onChange, leftValue, rightValue, leftLabel, rightLabel }) {
  const isRight = value === rightValue;
  return (
    <div className="slide-toggle" onClick={() => onChange(isRight ? leftValue : rightValue)}>
      <span className={'slide-toggle-label' + (!isRight ? ' active' : '')}>{leftLabel}</span>
      <span className={'slide-toggle-label' + (isRight ? ' active' : '')}>{rightLabel}</span>
      <div className={'slide-toggle-thumb' + (isRight ? ' right' : '')} />
    </div>
  );
}
